// src/components/admin/LicenseForm.js
import React, { useState, useEffect } from 'react';

const LicenseForm = ({ user = {}, initialData = {}, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    license_key: '',
    license_type: 'expiry', // Default to expiry
    valid_until: '',       // Date string (YYYY-MM-DD)
    max_tokens_per_month: '',
    activated: false,
    tenant_id: user?.tenant_id, // Auto-fill tenant_id
    // Set initial data, handling date formatting for input type="date"
    ...initialData,
    valid_until: initialData.valid_until ? new Date(initialData.valid_until).toISOString().split('T')[0] : '',
    // Convert numbers from null to empty string for form inputs if in add mode or if null
    max_tokens_per_month: initialData.max_tokens_per_month === null ? '' : (initialData.max_tokens_per_month || '')
  });

  const isEditMode = !!initialData.id;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (value === '' ? null : value) // Handle checkbox and empty string to null
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Prepare data for submission:
    const dataToSubmit = { ...formData };
    
    // Convert max_tokens_per_month to number if it's not null, otherwise keep null
    if (dataToSubmit.max_tokens_per_month !== null) {
      dataToSubmit.max_tokens_per_month = parseInt(dataToSubmit.max_tokens_per_month, 10);
      if (isNaN(dataToSubmit.max_tokens_per_month)) { // If parsing results in NaN, set to null
        dataToSubmit.max_tokens_per_month = null;
      }
    }
    
    // valid_until should be handled by backend as DateTime from ISO string
    // Activated_at and current_month_tokens_issued are managed by backend
    delete dataToSubmit.activated_at; 
    delete dataToSubmit.current_month_tokens_issued;
    delete dataToSubmit.last_month_reset_date;

    onSubmit(dataToSubmit, isEditMode);
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="admin-form-group">
        <label>License Key</label>
        <input type="text" name="license_key" value={formData.license_key} onChange={handleChange} required />
      </div>
      <div className="admin-form-group">
        <label>License Type</label>
        <select name="license_type" value={formData.license_type} onChange={handleChange} required>
          <option value="expiry">Expiry Date Based</option>
          <option value="monthly_limit">Monthly Token Limit</option>
          <option value="both">Both Expiry & Limit</option>
        </select>
      </div>

      {/* Conditional fields based on license type */}
      {(formData.license_type === 'expiry' || formData.license_type === 'both') && (
        <div className="admin-form-group">
          <label>Valid Until (Expiry Date)</label>
          <input type="date" name="valid_until" value={formData.valid_until || ''} onChange={handleChange} required={formData.license_type === 'expiry' || formData.license_type === 'both'} />
        </div>
      )}

      {(formData.license_type === 'monthly_limit' || formData.license_type === 'both') && (
        <div className="admin-form-group">
          <label>Max Tokens per Month</label>
          <input type="number" name="max_tokens_per_month" value={formData.max_tokens_per_month || ''} onChange={handleChange} required={formData.license_type === 'monthly_limit' || formData.license_type === 'both'} />
        </div>
      )}

      <div className="admin-form-group">
        <label>Activated</label>
        <input type="checkbox" name="activated" checked={formData.activated} onChange={handleChange} style={{ width: 'auto' }} />
      </div>

      <div className="admin-form-actions">
        <button type="submit" className="admin-button submit">{isEditMode ? 'Update License' : 'Add License'}</button>
        <button type="button" onClick={onCancel} className="admin-button cancel">Cancel</button>
      </div>
    </form>
  );
};

export default LicenseForm;